import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Message } from './aboboApiTypes'
import { createMessages } from './endpoints'

export const useMessages = () => {
  const { data: messages, error, mutate } = useSWR(`/messages`, swrFetcher<Message>)

  return {
    messages: messages?.data,
    isLoading: !error && !messages,
    isError: error,
    mutate,
    createMessage: (newMessage) => {
      return mutate(createMessages(newMessage), {
        populateCache: false,
        revalidate: true,
      });
    },
  }
}